// URL helpers for chat message parsing.

/**
 * Extract the first URL from a block of text, trimming punctuation and
 * brackets that get glued onto a URL when it's written inside prose.
 *
 * The naive `/(https?:\/\/[^\s]+)/` capture grabs everything up to the next
 * space, so "vezi https://exemplu.ro." captures the trailing period and
 * "(https://exemplu.ro)" captures the closing paren — both of which make the
 * backend's URL fetch fail. We trim trailing sentence punctuation and any
 * *unbalanced* closing bracket, while preserving brackets that are part of the
 * URL itself (e.g. Wikipedia `..._(disambiguation)`).
 *
 * @returns the cleaned URL, or `undefined` if no URL is present.
 */
export function extractFirstUrl(text: string): string | undefined {
  const match = text.match(/(https?:\/\/[^\s]+)/);
  if (!match) return undefined;

  let url = match[1].replace(/[.,;:!?'"]+$/, ""); // trailing sentence punctuation

  // Strip a trailing ) or ] only when it has no matching opener in the URL.
  while (/[)\]]$/.test(url)) {
    const close = url.at(-1) as string;
    const open = close === ")" ? "(" : "[";
    const opens = url.split(open).length - 1;
    const closes = url.split(close).length - 1;
    if (closes > opens) {
      url = url.slice(0, -1);
    } else {
      break;
    }
  }

  return url || undefined;
}
